import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { useNormalizedBYOLProviders } from './use-normalized-BYOL-providers';

// Filter out BYOL providers from Label Providers
export const useFilteredSellerLabelProviders = () => {
  const providers = useSelector(Global.selectSellerLabelProviders);
  const byolProviders = useNormalizedBYOLProviders();
  return useMemo(() => {
    return providers.filter((provider) => !byolProviders[provider.labelProviderId]);
  }, [providers, byolProviders]);
};
